import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

import { nonRiskyComorbidity, riskyComorbidity } from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import RiskFactorExplanation from 'on_web/components/shared/RiskFactorExplanation/RiskFactorExplanation';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontFamily: 'Museo',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.1,
    letterSpacing: 'normal',
    textAlign: 'left',
  },
  text: {
    fontSize: '20px',
    fontFamily: 'Museo',
    fontWeight: 'bold',
  },
  text2: {
    fontSize: '16px',
    fontFamily: 'Museo',
  },
}));

export default function CustomAccordion(props) {
  const classes = useStyles();

  const { t } = useTranslation();
  return (
    <Accordion className={classes.root} defaultExpanded={props.defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box display="flex" alignItems="center">
          <Box marginRight={3}>
            <img
              alt="risk"
              src={
                props.risk.level > 0 ? riskyComorbidity : nonRiskyComorbidity
              }
            />
          </Box>

          <Typography className={classes.heading}>
            {props.risk.risk.name}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box px={'20px'} py={'12px'}>
          <RiskFactorExplanation risk={props.risk} />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

CustomAccordion.propTypes = {
  risk: PropTypes.shape({
    /**
     * Comorbidity level
     */
    level: PropTypes.number.isRequired,

    /**
     * Label for comorbidity level.
     */
    level_label: PropTypes.string.isRequired,

    risk: PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  }),

  /**Is accordion expanded by default */
  defaultExpanded: PropTypes.bool,
};
